import React from "react";

function ExpertSupport_Hero(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 20 20"
      className={props.className}
    >
      <path
        stroke="#262626"
        strokeWidth="0.689"
        d="M6.826 8.894a3.447 3.447 0 100-6.894 3.447 3.447 0 000 6.894zm0 0c1.387 0 2.6.524 3.462 1.394.511.519.894 1.15 1.117 1.843m-4.58-3.237C4.069 8.894 2 10.962 2 13.719v3.447h6.894m.689-2.879l2.888 2.19 4.695-6.205"
      ></path>
    </svg>
  );
}

export default ExpertSupport_Hero;
